
import CommodityTypeList from './list.vue'
import CommodityTypeEdit from "./edit.vue";

let a = Object.assign({CommodityTypeList,CommodityTypeEdit});
export default a;